import qz from "qz-tray";
import { connectQZ } from "./qz-setup";

const PRINTER_NAME = "POS58 Printer";

// -------------------------------------------------------------
// COMMON PRINT FUNCTION
// -------------------------------------------------------------
const sendToPrinter = async (escpos) => {
  const config = qz.configs.create(PRINTER_NAME);

  const data = [
    {
      type: "raw",
      format: "plain",
      data: escpos,
    },
  ];

  await qz.print(config, data);
};

// -------------------------------------------------------------
// 1️⃣ INVOICE PRINT (Customer Copy)
// -------------------------------------------------------------
export const printInvoice = async (order) => {
  try {
    await connectQZ();

    const tokenNo = order.token_number;
    const createdAt = new Date(order.created_datetime).toLocaleString(
      "en-IN",
      { hour12: true, timeZone: "Asia/Kolkata" }
    );

    const items = order.order_details ?? [];
    const cgst = order.cgst || 0;
    const sgst = order.sgst || 0;
    const total_gst = order.total_gst || 0;
    const round_off = order.round_off || 0;
    const total_amount = order.total_amount || 0;
    const totalBeforeRoundOff = total_amount - round_off;

    let escpos = "";

    // Header
    escpos += "\x1B\x40"; // Initialize
    escpos += "\x1B\x61\x01"; // Center
    escpos += "\x1B\x21\x30"; // Double height + width
    escpos += "INVOICE\n";
    escpos += "\x1B\x21\x00"; // Normal size
    escpos += "\x1B\x61\x00"; // Left

    escpos += "Token No: " + tokenNo + "\n";
    escpos += "Date: " + createdAt + "\n";
    escpos += "--------------------------------\n";

    escpos += "Item            Qty   Price\n";

    items.forEach((item) => {
      const name = item.name.substring(0, 14).padEnd(14, " ");
      const qty = String(item.quantity).padEnd(5, " ");
      const price = item.price.toFixed(2);

      escpos += `${name}${qty}${price}\n`;
    });

    escpos += "--------------------------------\n";

    escpos += `CGST               ${cgst.toFixed(2)}\n`;
    escpos += `SGST               ${sgst.toFixed(2)}\n`;
    escpos += `Total GST          ${total_gst.toFixed(2)}\n`;

    escpos += `Total              ${totalBeforeRoundOff.toFixed(2)}\n`;
    escpos += `Round Off          ${round_off.toFixed(2)}\n`;

    escpos += "--------------------------------\n";
    escpos += `Grand Total        ${total_amount.toFixed(2)}\n`;

    escpos += "\n\n\n";
    escpos += "\x1D\x56\x00"; // Full Cut

    await sendToPrinter(escpos);
    console.log("Invoice printed successfully");
  } catch (err) {
    console.error("Invoice print error:", err);
  }
};

// -------------------------------------------------------------
// 2️⃣ KOT PRINT (Kitchen Order Ticket)
// One product per slip
// -------------------------------------------------------------
export const printKOT = async (order) => {
  try {
    await connectQZ();

    const tokenNo = order.token_number;
    const items = order.order_details ?? [];

    for (const item of items) {
      let escpos = "";

      escpos += "\x1B\x40"; // Initialize
      escpos += "\x1B\x61\x01"; // Center
      escpos += "\x1B\x21\x30"; // Double size
      escpos += "KOT\n";
      escpos += "\x1B\x21\x00"; // Normal
      escpos += "\x1B\x61\x00"; // Left

      escpos += "-----------------------------\n";

      escpos += "\x1B\x21\x30"; // Big item name
      escpos += item.name.toUpperCase() + "\n";
      escpos += "\x1B\x21\x00"; // Normal

      escpos += "Qty: " + item.quantity + "\n";
      escpos += "Token No: " + tokenNo + "\n";

      escpos += "-----------------------------\n";
      escpos += "\n\n\n";
      escpos += "\x1D\x56\x00"; // Cut

      await sendToPrinter(escpos);
    }

    console.log("KOT printed successfully");
  } catch (err) {
    console.error("KOT print error:", err);
  }
};

// -------------------------------------------------------------
// 3️⃣ MAIN FUNCTION → PRINT BOTH
// -------------------------------------------------------------
export const printReceipt = async (order) => {
  try {
    await printKOT(order);      // Kitchen first
    await printInvoice(order);  // Customer copy next
  } catch (err) {
    console.error("Print error:", err);
    alert("Thermal printing failed. Check QZ Tray.");
  }
};
